/**
 * 标题场景：游戏名 + 主菜单（开始游戏/排行榜/操作说明/音乐室）+ 版权声明。
 * 场景接口：enter(params)/exit()/update(dt)/draw(renderer)，切换用 this.mgr.switchTo。
 */
import { VIEW_W, VIEW_H } from '../config.js';
import { Input } from '../engine/input.js';
import { menuNav } from '../engine/menu.js';
import { EXTRA_DIFF } from '../content/difficulties.js';
import { t } from '../i18n.js';
import { GAME_VERSION } from '../version.js';

const MENU = ['menu.start', 'menu.extra', 'menu.practice', 'menu.replay', 'menu.leaderboard', 'menu.help', 'menu.musicRoom', 'menu.options', 'menu.credits'];

/** 操作说明覆盖层的文案 id（空串 = 空行）。 */
const HELP_LINES = [
  'help.title', '',
  'help.move', 'help.slow', 'help.shot', 'help.bomb', 'help.special', 'help.pause', 'help.fps', '',
  'help.items', 'help.poc', 'help.graze', '',
  'help.back',
];

export const TitleScene = {
  mgr: null,

  enter() {
    this.idx = 0;
    this.showHelp = false;
    this.t = 0;
    this.mgr.shared.audio.playBgm('bgm_title');
  },

  exit() {
    this.showHelp = false;
  },

  update(dt) {
    this.t += dt;
    const audio = this.mgr.shared.audio;
    if (this.showHelp) {
      if (Input.pressed('confirm') || Input.pressed('cancel')) {
        this.showHelp = false;
        audio.playSfx('select');
      }
      return;
    }
    const nav = menuNav(Input, audio, this.idx, MENU.length);
    if (nav !== null) this.idx = nav;
    if (Input.pressed('confirm')) {
      audio.playSfx('select');
      if (this.idx === 0) this.mgr.switchTo('difficultySelect');
      else if (this.idx === 1) this.mgr.switchTo('charSelect', { difficulty: EXTRA_DIFF, mode: 'extra' });
      else if (this.idx === 2) this.mgr.switchTo('spellPractice');
      else if (this.idx === 3) this.mgr.switchTo('replayList');
      else if (this.idx === 4) this.mgr.switchTo('leaderboard');
      else if (this.idx === 5) this.showHelp = true;
      else if (this.idx === 6) this.mgr.switchTo('musicRoom');
      else if (this.idx === 7) this.mgr.switchTo('options');
      else this.mgr.switchTo('credits');
    }
  },

  draw(r) {
    const assets = this.mgr.shared.assets;
    const bg = assets.img('bg1');
    if (bg) {
      const sc = Math.max(VIEW_W / bg.width, VIEW_H / bg.height);
      r.sprite(bg, VIEW_W / 2, VIEW_H / 2, { scale: sc, alpha: 0.55 });
    }
    r.rect(0, 0, VIEW_W, VIEW_H, { fill: '#000', alpha: 0.35 });

    // 标题（轻微浮动）
    const bob = Math.sin(this.t * 2) * 4;
    r.text('KIMI 弹幕大作战', VIEW_W / 2, 126 + bob, { size: 34, color: '#fff', align: 'center' });
    r.text('KIMI DANMAKU BATTLE', VIEW_W / 2, 168 + bob, { size: 12, color: '#8cf', align: 'center' });
    const kimi = assets.img('happy');
    if (kimi) {
      const sc = 72 / kimi.width;
      r.sprite(kimi, VIEW_W / 2, 252 + bob, { scale: sc });
    }

    // 菜单（箭头位置按文本实际宽度计算，任何语言/字体都不碰字）
    for (let i = 0; i < MENU.length; i++) {
      const y = 336 + i * 30;
      const sel = i === this.idx;
      const label = t(MENU[i]);
      if (sel) {
        const w = r.measure(label, { size: 18 });
        r.text('▶', VIEW_W / 2 - w / 2 - 22, y, { size: 18, color: '#ff4' });
      }
      r.text(label, VIEW_W / 2, y, { size: 18, color: sel ? '#ff4' : '#ccc', align: 'center' });
    }

    // 版本号（右下角，部署校验用）
    r.text(GAME_VERSION, VIEW_W - 8, VIEW_H - 10, { size: 10, color: '#556', align: 'right' });

    // 操作说明覆盖层
    if (this.showHelp) {
      r.rect(30, 90, VIEW_W - 60, VIEW_H - 180, { fill: '#001', alpha: 0.92, stroke: '#46f' });
      for (let i = 0; i < HELP_LINES.length; i++) {
        const line = HELP_LINES[i] ? t(HELP_LINES[i]) : '';
        r.text(line, 60, 112 + i * 23, { size: 12, color: i === 0 ? '#ff4' : '#dde' });
      }
    }
  },
};
